<template>
  <CContainer>
    <CRow class="justify-content-center">
      <CCol md="12" class="text-start">
        <CRow>
          <CCol class="d-flex">
            <div class="v3-module-list-title" role="heading" aria-level="2">
              Digital ID Card
            </div>
            <HelpCenterButton
              classes="ms-2"
              content-key="module_digital_id_card"
            />
          </CCol>
        </CRow>
        <div class="v3-module-list-box">
          <CCol class="v3-module-list-checkbox d-flex align-items-center">
            <CustomCheck
              label="QR Code As Default"
              :model-value="state.form.qrCode"
              :disabled="dependentOptionsDisabled"
              test-id="qrcode-checkbox"
              @change="checkQr"
            ></CustomCheck>
          </CCol>
          <CCol class="v3-module-list-checkbox d-flex align-items-center mt-2">
            <CustomCheck
              label="Barcode As Default"
              :model-value="state.form.barcode"
              :disabled="dependentOptionsDisabled"
              test-id="barcode-checkbox"
              @change="checkBarcode"
            ></CustomCheck>
          </CCol>
          <CCol class="v3-module-list-checkbox d-flex align-items-center mt-2">
            <CustomCheck
              label="National Suicide Prevention Hotline"
              :model-value="state.form.hotLine"
              :disabled="dependentOptionsDisabled"
              test-id="suicide-prevention-hotline-checkbox"
              @change="checkHotLine"
            ></CustomCheck>
          </CCol>
          <span class="small ms-4">
            (Include a link to the website and call/text number on student
            IDs)</span
          >
          <CCol class="v3-module-list-checkbox d-flex align-items-center">
            <CustomCheck
              label="Allow view of ID on student web device"
              :model-value="state.form.studentIdView"
              test-id="studentid-checkbox"
              @change="checkStudentIdView"
            ></CustomCheck>
          </CCol>
        </div>
        <CAlert
          v-if="state.reqResponse.message"
          dismissible
          class="mt-4"
          :color="state.reqResponse.type"
          :show="!!state.reqResponse.message"
          role="status"
          aria-live="polite"
          @close="resetResponseMessages"
        >
          {{ state.reqResponse.message }}
        </CAlert>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import HelpCenterButton from "../../HelpCenterButton.vue"
import CustomCheck from "@/v3components/shared/Form/CustomCheck.vue"
import { useStore } from "vuex"
import { onMounted, computed, reactive, ref } from "vue"

export default {
  name: "DigitalIdCardForm",
  components: { HelpCenterButton, CustomCheck },
  setup() {
    const store = useStore()

    const state = reactive({
      form: {
        qrCode: false,
        barcode: false,
        hotLine: false,
        studentIdView: false
      },
      reqResponse: {
        type: "",
        message: "",
        errors: {}
      }
    })

    const isLoading = ref(false)

    const options = computed(() => {
      const activeSchoolModules = store.state.schools.activeSchoolModules
      const index = activeSchoolModules.findIndex(
        (module) => module.name === "Digital ID Card"
      )
      return index !== -1
        ? JSON.parse(activeSchoolModules[index].pivot.option_json)
        : false
    })

    /** When student device view is off, QR / barcode / hotline cannot be edited */
    const dependentOptionsDisabled = computed(() => !state.form.studentIdView)

    onMounted(() => {
      if (options.value) {
        state.form.qrCode = Boolean(options.value.qr_code_as_default)
        state.form.barcode = Boolean(options.value.barcode_as_default)
        state.form.hotLine = Boolean(
          options.value.national_suicide_prevention_hotline
        )
        state.form.studentIdView = Boolean(
          !options.value.restrict_student_view_id
        )
      }
    })

    const checkBarcode = (value) => {
      state.form.barcode = value
      state.form.qrCode = false
      submit()
    }

    const checkQr = (value) => {
      state.form.qrCode = value
      state.form.barcode = false
      submit()
    }

    const checkStudentIdView = (value) => {
      state.form.studentIdView = value
      submit()
    }

    const checkHotLine = (value) => {
      state.form.hotLine = value
      submit()
    }

    const submit = () => {
      setTimeout(() => {
        resetResponseMessages()
        const inputsData = JSON.stringify({
          barcode_as_default: state.form.barcode,
          qr_code_as_default: state.form.qrCode,
          national_suicide_prevention_hotline: state.form.hotLine,
          restrict_student_view_id:
            state.form.studentIdView == true ? false : true
        })
        isLoading.value = true
        store
          .dispatch("modules/updateIdCardModule", { option_json: inputsData })
          .then(() => {
            setSuccessResponse("Successfully updated.")
            store
              .dispatch("schools/getActiveModules", {
                clearCacheEntry: true
              })
              .then(() => {
                state.form.barcode = Boolean(options.value.barcode_as_default)
                state.form.qrCode = Boolean(options.value.qr_code_as_default)
                state.form.hotLine = Boolean(
                  options.value.national_suicide_prevention_hotline
                )
                state.form.studentIdView = Boolean(
                  options.value.restrict_student_view_id == true ? false : true
                )
              })
            isLoading.value = false
          })
          .catch((err) => {
            const response = err.response.data
            setErrorResponse(response.message, response.errors)
            isLoading.value = false
          })
      }, 100)
    }

    const resetResponseMessages = () => {
      state.reqResponse = {
        type: "",
        message: "",
        errors: {}
      }
    }

    const setSuccessResponse = (message) => {
      state.reqResponse = {
        type: "success",
        message: message ? message : "Success!",
        errors: {}
      }
    }

    const setErrorResponse = (message, errors) => {
      state.reqResponse = {
        type: "danger",
        message: message ? message : "Something went wrong!",
        errors: errors ? errors : {}
      }
    }

    return {
      state,
      dependentOptionsDisabled,
      checkBarcode,
      checkQr,
      checkHotLine,
      checkStudentIdView,
      submit,
      resetResponseMessages
    }
  }
}
</script>
